<template>
  <div id="settings">
    <div class="container">
      <h1 class="mt-4">User Settings</h1>
      <!-- User Profile -->
      <form class="mt-4" @submit.prevent>
        <div class="form-group">
          <label for="name">User Name</label>
          <input v-model="profileData.name" type="text" id="name" class="form-control" />
        </div><!-- /.form-group -->
        <button @click="updateProfile()" class="btn btn-outline-secondary">Update User Name</button>
      </form>

      <form class="mt-4" @submit.prevent>
        <div class="form-group">
          <label>Email</label>
          <input class="form-control" v-model="newEmail" :placeholder="currentUser.email" />
        </div><!-- /.form-group -->
        <button class="btn btn-outline-secondary" @click="updateEmail()">Update Email</button>
      </form>

      <form class="mt-4" @submit.prevent>
        <div class="form-group">
          <label>New Password</label>
          <input class="form-control" v-model="newPassword" type="password" placeholder="******" />
        </div><!-- /.form-group -->
        <button class="btn btn-outline-secondary" @click="updatePassword()">Update Password</button>
      </form>

      <button class="btn btn-outline-warning mt-4" @click="logout()"><i class="fal fa-sign-out"></i> Log out</button>

    </div><!-- /.container -->

  </div><!-- /#settings -->
</template>

<script>
import { mapState } from 'vuex'
const fb = require('../firebaseConfig.js')

export default {
  data() {
    return {
      newPassword: '',
      newEmail: '',
      profileData: {
        name: ''
      }
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser'])
  },
  created() {
    let self = this
    setTimeout(function() {
      self.profileData = {
        name: self.userProfile.name || ''
      }
    }, 1000)
  },
  methods: {
    logout() {
      fb.auth.signOut().then(() => {
        this.$store.dispatch('clearData')
        this.$router.push('/')
      }).catch(err => {
        console.log(err)
      })
    },
    updateEmail() {
      let self = this
      fb.auth.currentUser.updateEmail(this.newEmail).then(function(){
        fb.usersCollection.doc(self.currentUser.uid).update({
          email: self.newEmail
        })
        alert('Successfully updated your email!')
        self.newEmail = ''
      }).catch(function(err){
        alert(err.message)
      })
    },
    updatePassword() {
      let self = this
      fb.auth.currentUser.updatePassword(this.newPassword).then(function(){
        alert('Successfully updated your password!')
        self.newPassword = ''
      }).catch(function(err){
        alert(err.message)
      })
    },
    updateProfile() {
      this.$store.dispatch('updateProfile', {
        name: this.profileData.name
      })
      alert('Successfully updated your profile!')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Settings.vue